
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("f2tcq", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $gdv5Z = parcelRequire("gdv5Z");


var $lGgRw = parcelRequire("lGgRw");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");


var $6Vqkv = parcelRequire("6Vqkv");


var $hYoU4 = parcelRequire("hYoU4");


var $bQm3c = parcelRequire("bQm3c");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");













var $2SlZp = parcelRequire("2SlZp");

var $7rvPL = parcelRequire("7rvPL");











var $56M4r = parcelRequire("56M4r");











var $1Whri = parcelRequire("1Whri");





var $hezkK = parcelRequire("hezkK");


var $26nu6 = parcelRequire("26nu6");

const $82c5dbca758f5691$var$styles = {
    root: "_kqswh2mm _kdam15tl"
};
const $82c5dbca758f5691$export$1233303c82069087 = (t0)=>{
    const $ = (0, $frIzR.c)(16);
    const { agent: agent, stackIndex: stackIndex, showBorder: showBorder } = t0;
    const t1 = showBorder && $82c5dbca758f5691$var$styles.root;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $1Whri.cx)(t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== stackIndex) {
        t3 = {
            zIndex: stackIndex
        };
        $[2] = stackIndex;
        $[3] = t3;
    } else t3 = $[3];
    const t4 = agent.id;
    const t5 = agent.id;
    const t6 = agent.identity_account_id;
    const t7 = agent.external_config_reference ?? agent.named_id;
    let t8;
    if ($[4] !== agent) {
        t8 = (0, $26nu6.isForgeAgent)(agent);
        $[4] = agent;
        $[5] = t8;
    } else t8 = $[5];
    let t9;
    if ($[6] !== agent.icon || $[7] !== agent.id || $[8] !== agent.identity_account_id || $[9] !== t7 || $[10] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hezkK.AgentAvatar), {
            key: t4,
            agentId: t5,
            agentIdentityAccountId: t6,
            agentNamedId: t7,
            size: "medium",
            showBorder: false,
            isForgeAgent: t8,
            forgeAgentIconUrl: agent.icon
        });
        $[6] = agent.icon;
        $[7] = agent.id;
        $[8] = agent.identity_account_id;
        $[9] = t7;
        $[10] = t8;
        $[11] = t9;
    } else t9 = $[11];
    let t10;
    if ($[12] !== t2 || $[13] !== t3 || $[14] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: t2,
            style: t3
        }, t9);
        $[12] = t2;
        $[13] = t3;
        $[14] = t9;
        $[15] = t10;
    } else t10 = $[15];
    return t10;
};


const $6721937fde404080$export$e32187f91d1fd188 = (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { agent: agent } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== createAnalyticsEvent) {
        t1 = (agentId)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "aiAgentPresenceGroupOverflowMenu",
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "aiAgentPresenceGroupOverflowMenuItem",
                    product: "confluence",
                    attributes: {
                        agentId: agentId
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = t1;
    } else t1 = $[1];
    const handleAgentClick = t1;
    let t2;
    if ($[2] !== agent.id || $[3] !== handleAgentClick) {
        t2 = ()=>handleAgentClick(agent.id);
        $[2] = agent.id;
        $[3] = handleAgentClick;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== agent) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $82c5dbca758f5691$export$1233303c82069087), {
            agent: agent
        });
        $[5] = agent;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== agent.id || $[8] !== agent.name || $[9] !== t2 || $[10] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
            key: agent.id,
            onClick: t2,
            iconBefore: t3
        }, agent.name);
        $[7] = agent.id;
        $[8] = agent.name;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
};


const $e2439a5908f943f7$var$i18n = (0, $cgtv4.defineMessages)({
    activeAgentsTitle: {
        id: "team-presence.agent-group-menu.title",
        defaultMessage: "{count, plural, =0 {Active agents ({count})} one {Active agents ({count})} other {Active agents ({count})}}"
    }
});
const $e2439a5908f943f7$var$styles = {
    root: "_2rko12b0 _bfhk1bhr _16qs130s _kqswh2mm _1bsb1gwv"
};
const $e2439a5908f943f7$export$62f6b3db6f977c3c = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { agents: agents } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    let t1;
    if ($[0] !== agents.length || $[1] !== formatMessage) {
        t1 = formatMessage($e2439a5908f943f7$var$i18n.activeAgentsTitle, {
            count: agents.length
        });
        $[0] = agents.length;
        $[1] = formatMessage;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== agents) {
        t2 = agents.map($e2439a5908f943f7$var$_temp);
        $[3] = agents;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $e2439a5908f943f7$var$styles.root
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2SlZp.default), {
            maxHeight: 480,
            minWidth: 360,
            maxWidth: 360
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rvPL.default), {
            isScrollable: true,
            title: t1
        }, t2)));
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
function $e2439a5908f943f7$var$_temp(agent) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6721937fde404080$export$e32187f91d1fd188), {
        key: agent.id,
        agent: agent
    });
}









var $2Pg7f = parcelRequire("2Pg7f");






















var $6f0Oj = parcelRequire("6f0Oj");

var $2W0qg = parcelRequire("2W0qg");

var $ecnYn = parcelRequire("ecnYn");




const $54c653dc38243ab4$var$i18n = (0, $cgtv4.defineMessages)({
    groupOverflowLabel: {
        id: "team-presence.group.overflow.label",
        defaultMessage: "Overflow menu"
    }
});
// Base styles for more indicator button - margin will be conditionally applied based on feature gate
const $54c653dc38243ab4$var$moreIndicatorButtonBaseStyle = (0, $ecnYn.xcss)({
    minWidth: '28px',
    padding: 'space.0',
    marginInline: 'space.0',
    marginBlock: 'space.025',
    backgroundColor: 'color.background.neutral.subtle',
    borderRadius: 'radius.small',
    ':focus-visible': {
        outlineColor: 'color.border.focused',
        outlineStyle: 'solid',
        outlineWidth: 'border.width.focused',
        outlineOffset: 'space.050'
    }
});
// Legacy margin styles (used when platform spacing fix is disabled)
const $54c653dc38243ab4$var$moreIndicatorButtonLegacyMarginStyle = (0, $ecnYn.xcss)({
    marginInline: 'space.025'
});
const $54c653dc38243ab4$var$moreIndicatorStyle = (0, $ecnYn.xcss)({
    padding: 'space.075',
    font: 'font.heading.xxsmall',
    color: 'color.text.subtle',
    backgroundColor: 'color.background.accent.gray.subtler',
    borderRadius: 'radius.full',
    ':hover': {
        backgroundColor: 'color.background.accent.gray.subtler.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.accent.gray.subtler.pressed'
    }
});
const $54c653dc38243ab4$var$moreIndicatorActiveStyle = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.selected',
    color: 'color.text.selected',
    ':hover': {
        backgroundColor: 'color.background.selected.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.selected.pressed'
    }
});
function $54c653dc38243ab4$export$20d7daf1abbf02fe(isOpen, count) {
    return (_, props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($54c653dc38243ab4$export$21d9599487cab049, {
            count: count,
            isOpen: isOpen,
            ...props
        });
    };
}
const $54c653dc38243ab4$export$21d9599487cab049 = (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { count: count, isOpen: isOpen, onClick: onClick, testId: testId } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage($54c653dc38243ab4$var$i18n.groupOverflowLabel);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [
            $54c653dc38243ab4$var$moreIndicatorButtonBaseStyle,
            !(0, $9wGTI.fg)("platform-avatar-group-spacing-fix") && $54c653dc38243ab4$var$moreIndicatorButtonLegacyMarginStyle
        ];
        $[2] = t2;
    } else t2 = $[2];
    const t3 = isOpen && $54c653dc38243ab4$var$moreIndicatorActiveStyle;
    let t4;
    if ($[3] !== t3) {
        t4 = [
            $54c653dc38243ab4$var$moreIndicatorStyle,
            t3
        ];
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== count || $[6] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: t4
        }, count);
        $[5] = count;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== onClick || $[9] !== t1 || $[10] !== t5 || $[11] !== testId) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            "data-vc": "presence-overflow",
            "aria-label": t1,
            onClick: onClick,
            testId: testId,
            xcss: t2
        }, t5);
        $[8] = onClick;
        $[9] = t1;
        $[10] = t5;
        $[11] = testId;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
};



const $b28d1d3ecd80ad2b$var$MAX_GROUP_SIZE = 4;
const $b28d1d3ecd80ad2b$var$styles = {
    root: "_195g1i6y"
};
const $b28d1d3ecd80ad2b$export$b69254d879536cde = (agents, count)=>{
    return (_, props, index)=>{
        const agent = agents.find((a)=>a.id === props.agentId);
        if (!agent) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)((0, $9wGTI.fg)('platform-avatar-group-spacing-fix') && $b28d1d3ecd80ad2b$var$styles.root)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $82c5dbca758f5691$export$1233303c82069087), {
            agent: agent,
            stackIndex: count - index,
            showBorder: true,
            ...props
        }));
    };
};
const $b28d1d3ecd80ad2b$export$192d6a5eae5d7b58 = (t0)=>{
    const $ = (0, $frIzR.c)(19);
    const { agents: agents, isOpen: isOpen, onMoreClick: onMoreClick } = t0;
    let t1;
    if ($[0] !== agents) {
        t1 = agents.map($b28d1d3ecd80ad2b$var$_temp);
        $[0] = agents;
        $[1] = t1;
    } else t1 = $[1];
    const data = t1;
    let t2;
    if ($[2] !== agents || $[3] !== data.length) {
        t2 = $b28d1d3ecd80ad2b$export$b69254d879536cde(agents, data.length);
        $[2] = agents;
        $[3] = data.length;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t2) {
        t3 = {
            render: t2
        };
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    const t4 = data.length - $b28d1d3ecd80ad2b$var$MAX_GROUP_SIZE + 1;
    let t5;
    if ($[7] !== isOpen || $[8] !== t4) {
        t5 = (0, $54c653dc38243ab4$export$20d7daf1abbf02fe)(isOpen, t4);
        $[7] = isOpen;
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== t5) {
        t6 = {
            render: t5
        };
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== t3 || $[13] !== t6) {
        t7 = {
            Avatar: t3,
            MoreIndicator: t6
        };
        $[12] = t3;
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== data || $[16] !== onMoreClick || $[17] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Pg7f.default), {
            testId: "agent-presence-avatar-group",
            appearance: "stack",
            size: "small",
            maxCount: $b28d1d3ecd80ad2b$var$MAX_GROUP_SIZE,
            data: data,
            shouldPopupRenderToParent: false,
            onMoreClick: onMoreClick,
            overrides: t7
        });
        $[15] = data;
        $[16] = onMoreClick;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    return t8;
};
function $b28d1d3ecd80ad2b$var$_temp(agent) {
    return {
        agentId: agent.id,
        name: agent.name
    };
}


const $4dfa4fcf3782a7bf$var$i18n = (0, $cgtv4.defineMessages)({
    agentGroupLabel: {
        id: "team-presence.agent-group.label",
        defaultMessage: "Active agents on content"
    }
});
const $4dfa4fcf3782a7bf$var$getUniqueAgents = (agents)=>{
    const uniqueAgents = new Map();
    agents?.forEach((agent)=>{
        if (agent) uniqueAgents.set(agent.id, agent);
    });
    return Array.from(uniqueAgents.values());
};
const $4dfa4fcf3782a7bf$export$3c0017d495bde3b3 = ()=>{
    const $ = (0, $frIzR.c)(21);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [t0] = (0, $hYoU4.useNativeCollabState)();
    const { collabEditProvider: collabEditProvider } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [activeAgents, setActiveAgents] = (0, $42omo.useState)(t1);
    const [isAgentGroupOverflowOpen, setIsAgentGroupOverflowOpen] = (0, $42omo.useState)(false);
    let t2;
    if ($[1] !== cloudId) {
        t2 = {
            assistanceServiceParams: {
                siteId: cloudId,
                product: "confluence",
                experienceId: "ai-mate",
                touchpointSource: "aiAgentPresence"
            }
        };
        $[1] = cloudId;
        $[2] = t2;
    } else t2 = $[2];
    const allAgentsFromAssistanceService = (0, $6Vqkv.useAgentsList)(t2);
    let t3;
    let t4;
    if ($[3] !== allAgentsFromAssistanceService || $[4] !== collabEditProvider) {
        t3 = ()=>{
            const handleUpdatePresence = ()=>{
                const agents = collabEditProvider?.getAIProviderParticipants().map((agent)=>{
                    const agentId = agent.userId.replace("agent:", "");
                    return allAgentsFromAssistanceService.find((a)=>a.id === agentId);
                });
                setActiveAgents($4dfa4fcf3782a7bf$var$getUniqueAgents(agents || []));
            };
            handleUpdatePresence();
            collabEditProvider?.on("presence", handleUpdatePresence);
            return ()=>{
                collabEditProvider?.off("presence", handleUpdatePresence);
            };
        };
        t4 = [
            allAgentsFromAssistanceService,
            collabEditProvider
        ];
        $[3] = allAgentsFromAssistanceService;
        $[4] = collabEditProvider;
        $[5] = t3;
        $[6] = t4;
    } else {
        t3 = $[5];
        t4 = $[6];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[7] !== createAnalyticsEvent) {
        t5 = (agentCount)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "aiAgentPresence",
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "aiAgentPresenceGroupOverflow",
                    product: "confluence",
                    attributes: {
                        agents: agentCount
                    }
                }
            }).fire();
            setIsAgentGroupOverflowOpen($4dfa4fcf3782a7bf$var$_temp);
        };
        $[7] = createAnalyticsEvent;
        $[8] = t5;
    } else t5 = $[8];
    const handleAgentGroupOverflowMenuClick = t5;
    let t6;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            setIsAgentGroupOverflowOpen(false);
        };
        $[9] = t6;
    } else t6 = $[9];
    const handleAgentGroupOverflowMenuClose = t6;
    let t7;
    if ($[10] !== activeAgents) {
        t7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e2439a5908f943f7$export$62f6b3db6f977c3c), {
                agents: activeAgents
            });
        $[10] = activeAgents;
        $[11] = t7;
    } else t7 = $[11];
    const renderAgentGroupOverflowMenu = t7;
    if (!activeAgents?.length) return null;
    let t8;
    if ($[12] !== activeAgents || $[13] !== formatMessage || $[14] !== handleAgentGroupOverflowMenuClick || $[15] !== isAgentGroupOverflowOpen) {
        t8 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                ...triggerProps,
                paddingInline: "space.025",
                "aria-label": formatMessage($4dfa4fcf3782a7bf$var$i18n.agentGroupLabel),
                role: "region"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b28d1d3ecd80ad2b$export$192d6a5eae5d7b58), {
                agents: activeAgents,
                isOpen: isAgentGroupOverflowOpen,
                onMoreClick: ()=>handleAgentGroupOverflowMenuClick(activeAgents.length)
            }));
        $[12] = activeAgents;
        $[13] = formatMessage;
        $[14] = handleAgentGroupOverflowMenuClick;
        $[15] = isAgentGroupOverflowOpen;
        $[16] = t8;
    } else t8 = $[16];
    let t9;
    if ($[17] !== isAgentGroupOverflowOpen || $[18] !== renderAgentGroupOverflowMenu || $[19] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            placement: "bottom-end",
            isOpen: isAgentGroupOverflowOpen,
            onClose: handleAgentGroupOverflowMenuClose,
            content: renderAgentGroupOverflowMenu,
            trigger: t8
        });
        $[17] = isAgentGroupOverflowOpen;
        $[18] = renderAgentGroupOverflowMenu;
        $[19] = t8;
        $[20] = t9;
    } else t9 = $[20];
    return t9;
};
const $4dfa4fcf3782a7bf$export$b5ab3015117320e0 = ()=>{
    const $ = (0, $frIzR.c)(1);
    if ((0, $9wGTI.fg)("remove_use_agents_list_usage")) return null;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).COLLABORATION_PRESENCE
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4dfa4fcf3782a7bf$export$3c0017d495bde3b3, {
            "data-vc": "aiAgentPresence"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
function $4dfa4fcf3782a7bf$var$_temp(isAgentGroupOverflowOpenState) {
    return !isAgentGroupOverflowOpenState;
}
module.exports["AgentPresenceComponent"] = $4dfa4fcf3782a7bf$export$3c0017d495bde3b3;
module.exports["AgentPresence"] = $4dfa4fcf3782a7bf$export$b5ab3015117320e0;

});

parcelRegister("i0btU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");

var $8C5kA = parcelRequire("8C5kA");


var $bwC67 = parcelRequire("bwC67");

const $806263e9564ebacc$var$EMPTY = {};
const $806263e9564ebacc$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState($806263e9564ebacc$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        let aborted = false;
        setMessages($806263e9564ebacc$var$EMPTY);
        (0, $bwC67.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $806263e9564ebacc$var$MessagesIntlProvider = (props)=>{
    const { children: children } = props;
    const intl = (0, $8C5kA.default)();
    const messages = $806263e9564ebacc$var$useI18n(intl.locale);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1e2E5.default), {
        ...intl,
        messages: messages
    }, children);
};
var $806263e9564ebacc$export$2e2bcd8739ae039 = $806263e9564ebacc$var$MessagesIntlProvider;
module.exports["default"] = $806263e9564ebacc$export$2e2bcd8739ae039;

});

parcelRegister("bwC67", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $gjAAG = parcelRequire("gjAAG");

const $1cb8431546098045$export$392a0c6a82ab0e50 = (messageDescriptor)=>({ values: values, children: children })=>{
        const { formatMessage: formatMessage } = (0, $8C5kA.default)();
        const message = formatMessage(messageDescriptor, values);
        if (typeof children === 'function') return children(message);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            values: values,
            ...messageDescriptor
        });
    };
const $1cb8431546098045$export$98e06fe7a6174253 = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).unknownUserError);
const $1cb8431546098045$export$58bd5a2057b6b855 = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).noAccessWarning);
const $1cb8431546098045$export$da9f8ce14593162f = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).noAccessLabel);
const $1cb8431546098045$export$4a258ffee7316766 = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).defaultHeadline);
const $1cb8431546098045$export$702321a50d74536e = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).defaultAdvisedAction);
const $1cb8431546098045$export$ed7f16088a93ae9d = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).loginAgain);
const $1cb8431546098045$export$3ab158df56460d1c = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).differentText);































const $1cb8431546098045$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("gc0Sn")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("hcZqU")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("aOvw3")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("5twea")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("6MZNH")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("2Uiuu")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("2uKrW")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("8ZVHr")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("fPG5T")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("2G88k")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("eK5ZS")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("dJ6Pi")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("aWbdl")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("ixJvt")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("cqdNY")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("kue1N")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("i6Vz0")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("5yoki")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("5JAzL")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("eD8co")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("kjxyJ")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("iO2Mq")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("dVKWy")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("4CuhE")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("dct7i")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("cz3Nf")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("9677e")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("lksJj")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("QyjlH")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("bljzq")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $1cb8431546098045$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("5twea")).then((mod)=>mod.default);
            }
    }
};
module.exports["UnknownUserError"] = $1cb8431546098045$export$98e06fe7a6174253;
module.exports["NoAccessWarning"] = $1cb8431546098045$export$58bd5a2057b6b855;
module.exports["NoAccessLabel"] = $1cb8431546098045$export$da9f8ce14593162f;
module.exports["DefaultHeadline"] = $1cb8431546098045$export$4a258ffee7316766;
module.exports["DefaultAdvisedAction"] = $1cb8431546098045$export$702321a50d74536e;
module.exports["LoginAgain"] = $1cb8431546098045$export$ed7f16088a93ae9d;
module.exports["DifferentText"] = $1cb8431546098045$export$3ab158df56460d1c;
module.exports["getMessagesForLocale"] = $1cb8431546098045$export$d0a3169680473b6c;

});

parcelRegister("gjAAG", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $898c0db98da1400a$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    unknownUserError: {
        id: "fabric.mention.unknow.user.error",
        defaultMessage: "Unknown user {userId}"
    },
    noAccessWarning: {
        id: "fabric.mention.noAccess.warning",
        defaultMessage: "{name} won't be notified as they have no access"
    },
    noAccessLabel: {
        id: "fabric.mention.noAccess.label",
        defaultMessage: "No access"
    },
    defaultHeadline: {
        id: "fabric.mention.error.defaultHeadline",
        defaultMessage: "Something went wrong"
    },
    defaultAdvisedAction: {
        id: "fabric.mention.error.defaultAction",
        defaultMessage: "Try again in a few seconds"
    },
    loginAgain: {
        id: "fabric.mention.error.loginAgain",
        defaultMessage: "Try logging out then in again"
    },
    differentText: {
        id: "fabric.mention.error.differentText",
        defaultMessage: "Try entering different text"
    },
    memberCountWithoutYou: {
        id: "fabric.elements.mentions.team.member.count",
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}"
    },
    memberCountWithYou: {
        id: "fabric.elements.mentions.team.member.count.including.you",
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}, including you"
    },
    plus50MembersWithoutYou: {
        id: "fabric.elements.mentions.team.member.50plus",
        defaultMessage: "Team \u2022 50+ members"
    },
    plus50MembersWithYou: {
        id: "fabric.elements.mentions.team.member.50plus.including.you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    xProductMentionDescription: {
        id: "fabric.elements.mentions.xproduct.mention.description",
        defaultMessage: "Needs access to Confluence"
    }
});
module.exports["messages"] = $898c0db98da1400a$export$defe85febe8b728c;

});

parcelRegister("gc0Sn", function(module, exports) {

let $bc9e725213fc1860$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bc9e725213fc1860$var$load("4Mixi"),
    $bc9e725213fc1860$var$load("1jsQH"),
    $bc9e725213fc1860$var$load("bv8GZ"),
    $bc9e725213fc1860$var$load("i5eMd"),
    $bc9e725213fc1860$var$load("4DYJ5"),
    $bc9e725213fc1860$var$load("gyXEE"),
    $bc9e725213fc1860$var$load("hoPZ9")
]).then(()=>parcelRequire('6Yuab'));

});

parcelRegister("hcZqU", function(module, exports) {

let $c87335f8193b858e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c87335f8193b858e$var$load("cjveN"),
    $c87335f8193b858e$var$load("deyvi"),
    $c87335f8193b858e$var$load("cdeuH"),
    $c87335f8193b858e$var$load("4UPfH"),
    $c87335f8193b858e$var$load("hfFxJ"),
    $c87335f8193b858e$var$load("1Mp9N"),
    $c87335f8193b858e$var$load("2Fu3d")
]).then(()=>parcelRequire('biDFC'));

});

parcelRegister("aOvw3", function(module, exports) {

let $7df705563369f7c9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7df705563369f7c9$var$load("8XGJb"),
    $7df705563369f7c9$var$load("6dERU"),
    $7df705563369f7c9$var$load("7gF8f"),
    $7df705563369f7c9$var$load("gd4qs"),
    $7df705563369f7c9$var$load("gofGr"),
    $7df705563369f7c9$var$load("dBb6q"),
    $7df705563369f7c9$var$load("eJgH8")
]).then(()=>parcelRequire('e7zr1'));

});

parcelRegister("5twea", function(module, exports) {

let $3fc8a8e755b35ba7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3fc8a8e755b35ba7$var$load("2YffH").then(()=>parcelRequire('gbdrY'));

});

parcelRegister("6MZNH", function(module, exports) {

let $4f172a150f653863$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4f172a150f653863$var$load("hdvZr"),
    $4f172a150f653863$var$load("kTurq"),
    $4f172a150f653863$var$load("djb49"),
    $4f172a150f653863$var$load("fviv5"),
    $4f172a150f653863$var$load("2RQvP"),
    $4f172a150f653863$var$load("7Lkvk")
]).then(()=>parcelRequire('4ykQ2'));

});

parcelRegister("2Uiuu", function(module, exports) {

let $21df27994f190a89$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $21df27994f190a89$var$load("4ViGN"),
    $21df27994f190a89$var$load("j0PWv"),
    $21df27994f190a89$var$load("ksTQ6"),
    $21df27994f190a89$var$load("eBoC7"),
    $21df27994f190a89$var$load("7NpX8"),
    $21df27994f190a89$var$load("cukQS"),
    $21df27994f190a89$var$load("5FaEJ")
]).then(()=>parcelRequire('4FRcU'));

});

parcelRegister("2uKrW", function(module, exports) {

let $1d126a0b05e5aec8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1d126a0b05e5aec8$var$load("32vlK"),
    $1d126a0b05e5aec8$var$load("dlmud"),
    $1d126a0b05e5aec8$var$load("5CGnz"),
    $1d126a0b05e5aec8$var$load("bNv64"),
    $1d126a0b05e5aec8$var$load("bFU3Y"),
    $1d126a0b05e5aec8$var$load("3CucM"),
    $1d126a0b05e5aec8$var$load("9yemY")
]).then(()=>parcelRequire('bG4aH'));

});

parcelRegister("8ZVHr", function(module, exports) {

let $68d0c72d3e46e583$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $68d0c72d3e46e583$var$load("7snhF"),
    $68d0c72d3e46e583$var$load("X0Jic"),
    $68d0c72d3e46e583$var$load("bAoKR"),
    $68d0c72d3e46e583$var$load("5IaSN")
]).then(()=>parcelRequire('kVRsY'));

});

parcelRegister("fPG5T", function(module, exports) {

let $b86c45698d9f7cb3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b86c45698d9f7cb3$var$load("bjoGV"),
    $b86c45698d9f7cb3$var$load("cbkj0"),
    $b86c45698d9f7cb3$var$load("9Oxgj"),
    $b86c45698d9f7cb3$var$load("4Afgd"),
    $b86c45698d9f7cb3$var$load("exaJ2"),
    $b86c45698d9f7cb3$var$load("lp8Wm"),
    $b86c45698d9f7cb3$var$load("l2LZP")
]).then(()=>parcelRequire('FrZOj'));

});

parcelRegister("2G88k", function(module, exports) {

let $1f35d0269ed342f5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1f35d0269ed342f5$var$load("8oiz7"),
    $1f35d0269ed342f5$var$load("17m16"),
    $1f35d0269ed342f5$var$load("kAg8V"),
    $1f35d0269ed342f5$var$load("cMubu"),
    $1f35d0269ed342f5$var$load("hcCcg"),
    $1f35d0269ed342f5$var$load("cHWSM"),
    $1f35d0269ed342f5$var$load("35Ssm")
]).then(()=>parcelRequire('225Fx'));

});

parcelRegister("eK5ZS", function(module, exports) {

let $abba03711e07d60b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $abba03711e07d60b$var$load("hFxmj"),
    $abba03711e07d60b$var$load("b4NO6"),
    $abba03711e07d60b$var$load("fM2oh"),
    $abba03711e07d60b$var$load("3fLE9"),
    $abba03711e07d60b$var$load("j9KTb"),
    $abba03711e07d60b$var$load("b37xN"),
    $abba03711e07d60b$var$load("ik6u5")
]).then(()=>parcelRequire('alG1N'));

});

parcelRegister("dJ6Pi", function(module, exports) {

let $9fe4c5e3bbeeb3c3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9fe4c5e3bbeeb3c3$var$load("fModo").then(()=>parcelRequire('lQyzT'));

});

parcelRegister("aWbdl", function(module, exports) {

let $7f68051353093946$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7f68051353093946$var$load("BXOZB"),
    $7f68051353093946$var$load("1K1Fj"),
    $7f68051353093946$var$load("xnqy2"),
    $7f68051353093946$var$load("8hOn0"),
    $7f68051353093946$var$load("3hjAq"),
    $7f68051353093946$var$load("7PjNK"),
    $7f68051353093946$var$load("Vt6S9")
]).then(()=>parcelRequire('gSUUF'));

});

parcelRegister("ixJvt", function(module, exports) {

let $d7fe9bb6f09886dc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d7fe9bb6f09886dc$var$load("9Xiuh"),
    $d7fe9bb6f09886dc$var$load("38sfA"),
    $d7fe9bb6f09886dc$var$load("awkVi"),
    $d7fe9bb6f09886dc$var$load("h4OCL"),
    $d7fe9bb6f09886dc$var$load("2bCHJ"),
    $d7fe9bb6f09886dc$var$load("ktSfi"),
    $d7fe9bb6f09886dc$var$load("9GZ76")
]).then(()=>parcelRequire('cF55v'));

});

parcelRegister("cqdNY", function(module, exports) {

let $90b29f1c573026bb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $90b29f1c573026bb$var$load("7Odo3"),
    $90b29f1c573026bb$var$load("bjmre"),
    $90b29f1c573026bb$var$load("11DLa"),
    $90b29f1c573026bb$var$load("bcQs2"),
    $90b29f1c573026bb$var$load("fdXnq"),
    $90b29f1c573026bb$var$load("iouLY"),
    $90b29f1c573026bb$var$load("4sOIV")
]).then(()=>parcelRequire('4IbNl'));

});

parcelRegister("kue1N", function(module, exports) {

let $eea17da0a05dcf3d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $eea17da0a05dcf3d$var$load("4VkvT"),
    $eea17da0a05dcf3d$var$load("asvK9"),
    $eea17da0a05dcf3d$var$load("barSq"),
    $eea17da0a05dcf3d$var$load("aBa7j"),
    $eea17da0a05dcf3d$var$load("cItJR"),
    $eea17da0a05dcf3d$var$load("hPZE5"),
    $eea17da0a05dcf3d$var$load("QTjdE")
]).then(()=>parcelRequire('jKge3'));

});

parcelRegister("i6Vz0", function(module, exports) {

let $d2f570796bc265af$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d2f570796bc265af$var$load("g5qJV"),
    $d2f570796bc265af$var$load("7v6wU"),
    $d2f570796bc265af$var$load("a8heY"),
    $d2f570796bc265af$var$load("b544F"),
    $d2f570796bc265af$var$load("SctKm"),
    $d2f570796bc265af$var$load("dzIm8"),
    $d2f570796bc265af$var$load("hrf1M")
]).then(()=>parcelRequire('lGLcJ'));

});

parcelRegister("5yoki", function(module, exports) {

let $40b2ff6c7676afac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $40b2ff6c7676afac$var$load("dPa6p"),
    $40b2ff6c7676afac$var$load("aEpRh"),
    $40b2ff6c7676afac$var$load("6hlNE"),
    $40b2ff6c7676afac$var$load("K6fhx"),
    $40b2ff6c7676afac$var$load("1fJz1"),
    $40b2ff6c7676afac$var$load("jqwnR"),
    $40b2ff6c7676afac$var$load("lsloj")
]).then(()=>parcelRequire('d7PIu'));

});

parcelRegister("5JAzL", function(module, exports) {

let $42cd86e7efc12666$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $42cd86e7efc12666$var$load("iG4uh"),
    $42cd86e7efc12666$var$load("3fuR9"),
    $42cd86e7efc12666$var$load("2bqSD"),
    $42cd86e7efc12666$var$load("gZU54"),
    $42cd86e7efc12666$var$load("9yA8o"),
    $42cd86e7efc12666$var$load("bGhLc"),
    $42cd86e7efc12666$var$load("iRKhU")
]).then(()=>parcelRequire('jwd3r'));

});

parcelRegister("eD8co", function(module, exports) {

let $aa6b115a311b9fd0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aa6b115a311b9fd0$var$load("aGECO").then(()=>parcelRequire('c2Dmg'));

});

parcelRegister("kjxyJ", function(module, exports) {

let $ec9f9d22a0e12245$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ec9f9d22a0e12245$var$load("bSjyK"),
    $ec9f9d22a0e12245$var$load("j6IGj"),
    $ec9f9d22a0e12245$var$load("hlJc4"),
    $ec9f9d22a0e12245$var$load("aOdaf")
]).then(()=>parcelRequire('l9Ug4'));

});

parcelRegister("iO2Mq", function(module, exports) {

let $db0f0d95377eff3a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $db0f0d95377eff3a$var$load("9tVE8"),
    $db0f0d95377eff3a$var$load("fMrUo"),
    $db0f0d95377eff3a$var$load("bJykp"),
    $db0f0d95377eff3a$var$load("4Wdqb"),
    $db0f0d95377eff3a$var$load("448N7"),
    $db0f0d95377eff3a$var$load("9v6ER"),
    $db0f0d95377eff3a$var$load("aEAsN")
]).then(()=>parcelRequire('fkCIe'));

});

parcelRegister("dVKWy", function(module, exports) {

let $a245033a20d44784$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a245033a20d44784$var$load("5WkxF").then(()=>parcelRequire('hW2zm'));

});

parcelRegister("4CuhE", function(module, exports) {

let $35d233bcb00da461$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $35d233bcb00da461$var$load("6UAlo"),
    $35d233bcb00da461$var$load("9eNkX"),
    $35d233bcb00da461$var$load("dh2Er"),
    $35d233bcb00da461$var$load("k10Cs"),
    $35d233bcb00da461$var$load("gBDdh"),
    $35d233bcb00da461$var$load("8Mz40"),
    $35d233bcb00da461$var$load("l6YHr")
]).then(()=>parcelRequire('gR0Ux'));

});

parcelRegister("dct7i", function(module, exports) {

let $99c2fb5138729985$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $99c2fb5138729985$var$load("l7PQP").then(()=>parcelRequire('bRxNE'));

});

parcelRegister("cz3Nf", function(module, exports) {

let $925bb22c48477eb2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $925bb22c48477eb2$var$load("9Yw4z"),
    $925bb22c48477eb2$var$load("h0uBE"),
    $925bb22c48477eb2$var$load("eBLgB"),
    $925bb22c48477eb2$var$load("1n8w9"),
    $925bb22c48477eb2$var$load("6NHX3"),
    $925bb22c48477eb2$var$load("77dzh")
]).then(()=>parcelRequire('4dnaM'));

});

parcelRegister("9677e", function(module, exports) {

let $69fa319b49dca515$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $69fa319b49dca515$var$load("fLjHM").then(()=>parcelRequire('2qq54'));

});

parcelRegister("lksJj", function(module, exports) {

let $f871c05e7ad2e071$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f871c05e7ad2e071$var$load("3YGga").then(()=>parcelRequire('7iyzo'));

});

parcelRegister("QyjlH", function(module, exports) {

let $09df78e8bc3317cb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $09df78e8bc3317cb$var$load("ia9y3"),
    $09df78e8bc3317cb$var$load("j9OUx"),
    $09df78e8bc3317cb$var$load("bV8sS"),
    $09df78e8bc3317cb$var$load("l079e"),
    $09df78e8bc3317cb$var$load("ebljE"),
    $09df78e8bc3317cb$var$load("hF4v3"),
    $09df78e8bc3317cb$var$load("afU9w")
]).then(()=>parcelRequire('lRTsu'));

});

parcelRegister("bljzq", function(module, exports) {

let $8420d62759605432$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8420d62759605432$var$load("15ncj"),
    $8420d62759605432$var$load("gDiIK"),
    $8420d62759605432$var$load("eLlpV"),
    $8420d62759605432$var$load("f1B4n"),
    $8420d62759605432$var$load("j4dSZ"),
    $8420d62759605432$var$load("1Tuyb"),
    $8420d62759605432$var$load("7iCpI")
]).then(()=>parcelRequire('jKBtA'));

});

parcelRegister("l2474", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $d23df821b2d2d994$var$AsyncNoAccessTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("gURmQ")).then((module)=>{
        return {
            default: module.NoAccessTooltip
        };
    }));
var $d23df821b2d2d994$export$2e2bcd8739ae039 = $d23df821b2d2d994$var$AsyncNoAccessTooltip;
module.exports["default"] = $d23df821b2d2d994$export$2e2bcd8739ae039;

});

parcelRegister("gURmQ", function(module, exports) {

let $c50b45f90fc6d653$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c50b45f90fc6d653$var$load("2lsX7").then(()=>parcelRequire('5zTqW'));

});


//# sourceMappingURL=AgentPresence.e446f603.js.map
